import {Deserializable} from "./deserializable.model";

// :: @ Brand and User fields combigned for Grid Result.

export class SearchContact {
user_id: number;
  first_name: string;
  surname: string;
  address_1: string;
  address_2: string;
  state: string;
  postcode: string;
  suburb: string;
  country: string;
  phone: string;
  mobile: string;
  email_address: string;
  website: string;
  username: string;
  password: string;
  access_level: number;
  is_active: string;
  last_logged_in: string;
  times_logged_in: string;
  date_joined: string;
  marketing: string;
  company_name: string;
  c_name_stripped: string;
  photo: string;
  profile: string;
  postion: string;
  user_position_id: number;
  weight: string;
  field_of_interest_id: number;
  b_sector_id: number;
  b_sector_cat_id: number;
  fax: string;
  disabled_login_date: string;
  brand_id: number;

  name: string;
  email: string;
  user_name: string;
  password_hash: string;
  api_key: string;
  status: number;
  id: number;  // currently this is the primary Key? (and uses this for login)
  created_at: string;
  token: string;

 // brand_id: number;
 // name: string;
 // profile: string;
  sef_name: string;
  keywords: string;
  logo: string;
 // phone: string;
 // fax: string;
 // email: string;
 // website: string;
  listing_cat_id: number;
  brand_id__: number;
 // is_active: string;
  created: string;
  updated: string;
  created_by: number;
  updated_by: number;
  is_represented: string;
  address: string;
  main_listing: string;
  // address_1: string;
  // address_2: string;
  // suburb: string;
  // state: string;
  // postcode: string;
  // country: string;
  custom_report_pdf: string;
  report_logo: string;
  report_cover_bg: string;
  report_general_bg: string;
  report_colour_base: string;
  brand_type_id?: number;
  brand_notes: string;
myob_id: string;
postal_address_1: string;
postal_address_2: string;
postal_suburb: string;
postal_state: string;
postal_country: string;
qualification: string;
qualification_number: string;
qualification_renewal_date: string;
accounts_email_address: string;
postal_postcode: number;

created_date_from: string;
created_date_to: string;

  // ? what does this really do? (no encoding or deserialisation required...)
  deserialize(input: any): SearchContact {
    Object.assign(this, input);

    return this;
  }


}
